/**
 * HMS コード逆引きの絞り込み。
 * 全行はサーバー描画済みなので、ここでやるのは表示・非表示だけ。JS が落ちても内容は読める。
 */
(function () {
  'use strict';

  var list = document.getElementById('sk-bhms-list');
  if (!list) return;

  var q = document.getElementById('sk-bhms-q');
  var hit = document.getElementById('sk-bhms-hit');
  var empty = document.getElementById('sk-bhms-empty');
  var clear = document.getElementById('sk-bhms-clear');
  var chips = document.querySelectorAll('.sk-bhms__chip');
  var rows = Array.prototype.slice.call(list.querySelectorAll('.sk-bhms__row'));
  var machine = '';
  var timer = null;
  var composing = false;

  // 検索語はコード表記のゆれ（- と _ と空白）を吸収する
  function normalize(s) {
    return String(s || '').normalize('NFKC').toLowerCase().trim()
      .replace(/[‐‑‒–—−]/g, '-').replace(/\s+/g, ' ');
  }

  function codeKey(s) {
    var text = normalize(s).replace(/^hms[\s:_-]*/, '');
    return /^[a-f0-9\s_-]+$/.test(text) ? text.replace(/[\s_-]/g, '') : '';
  }

  function matchesMachine(el) {
    return !machine || (' ' + (el.getAttribute('data-m') || '') + ' ').indexOf(' ' + machine + ' ') !== -1;
  }

  function selectMachine(value) {
    machine = value;
    for (var j = 0; j < chips.length; j++) {
      var on = chips[j].getAttribute('data-m') === machine;
      chips[j].classList.toggle('is-on', on);
      chips[j].setAttribute('aria-pressed', String(on));
    }
  }

  // 検索対象はコードと日本語のエラー文だけ。
  // 行に検索用の属性を持たせると 573 行ぶんで HTML が数十KB 増えるので、
  // 読み込み時に一度だけ組み立てる。リンクの文言（「公式の対処」等）は入れない
  // ——全行に出るので、入れると検索が素通りしてしまう。
  var haystack = rows.map(function (row) {
    // 1行に複数のコード（スロット違い）と複数の文面（機種で表記が違う）が入ることがある。
    // 利用者は自分の画面の文字で探すので、その行が持つ全部を検索対象にする。
    var codes = row.querySelectorAll('.sk-bhms__code');
    var lines = Array.prototype.slice.call(row.querySelectorAll('.sk-bhms__line'));
    return {
      codes: Array.prototype.map.call(codes, function (c) { return codeKey(c.textContent); }),
      lines: lines.map(function (line) { return { el: line, text: normalize(line.querySelector('.sk-bhms__msg').textContent) }; }),
      fallback: normalize(Array.prototype.map.call(row.querySelectorAll('.sk-bhms__msg'), function (m) { return m.textContent; }).join(' '))
    };
  });

  // 全コードから表示行を引く。まとめた2個目以降のコードも直接開ける。
  var byCode = Object.create(null);
  rows.forEach(function (row) {
    (row.getAttribute('data-codes') || row.id).split(' ').forEach(function (code) {
      if (code) byCode[codeKey(code)] = row;
    });
  });

  function saveQuery() {
    if (!/^https?:$/.test(location.protocol)) return;
    var url = new URL(location.href);
    var term = (q && q.value || '').trim();
    if (term) url.searchParams.set('q', term); else url.searchParams.delete('q');
    if (machine) url.searchParams.set('m', machine); else url.searchParams.delete('m');
    url.hash = '';
    try { history.replaceState(null, '', url); } catch (e) { return; }
    rows.forEach(function (r) { r.classList.remove('is-target'); });
  }

  function chipLabel() {
    for (var j = 0; j < chips.length; j++) {
      if (chips[j].getAttribute('data-m') === machine) {
        return chips[j].getAttribute('title') || chips[j].textContent;
      }
    }
    return '';
  }

  function apply(writeUrl) {
    var term = normalize(q && q.value);
    var code = codeKey(term);
    var words = term.split(' ');
    var shown = 0;
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var okM = matchesMachine(row);
      var entry = haystack[i];
      var texts = entry.lines.filter(function (l) { return matchesMachine(l.el); }).map(function (l) { return l.text; });
      if (!entry.lines.length) texts.push(entry.fallback);
      var okQ = !term || (code ? entry.codes.some(function (c) { return c.indexOf(code) !== -1; })
        : texts.some(function (text) { return words.every(function (word) { return text.indexOf(word) !== -1; }); }));
      var on = okM && okQ;
      row.hidden = !on;
      entry.lines.forEach(function (l) { l.el.hidden = !matchesMachine(l.el); });
      Array.prototype.forEach.call(row.querySelectorAll('details[data-m]'), function (d) { d.hidden = !matchesMachine(d); });
      if (on) shown++;
    }
    if (hit) {
      // 何で絞った結果の件数かを書く。件数だけだと、機種チップを押したことを
      // 忘れて「検索しても出てこない」と見える（スマホは絞り込みが画面外に行く）。
      if (!term && !machine) {
        hit.textContent = '';
      } else {
        var cond = [];
        if (machine) cond.push(chipLabel());
        if (term) cond.push('「' + (q.value || '').trim() + '」');
        hit.textContent = cond.join(' / ') + ' で ';
        var count = document.createElement('strong');
        count.textContent = String(shown);
        hit.appendChild(count);
        hit.appendChild(document.createTextNode(' 件'));
      }
    }
    if (clear) clear.hidden = !(term || machine);
    if (empty) empty.hidden = shown !== 0;
    if (writeUrl) saveQuery();
  }

  function reset() {
    selectMachine('');
    if (q) q.value = '';
    apply(true);
    if (q) q.focus();
  }

  if (q) {
    function scheduleSearch() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { apply(true); }, 120);
    }
    q.addEventListener('compositionstart', function () {
      composing = true;
      if (timer) clearTimeout(timer);
    });
    q.addEventListener('compositionend', function () {
      composing = false;
      scheduleSearch();
    });
    q.addEventListener('input', function (e) {
      if (composing || e.isComposing) return;
      scheduleSearch();
    });
    // スマホのキーボードの「検索」でフォームが飛ばないように（このページ内で完結する）
    q.addEventListener('keydown', function (e) {
      // 変換確定のEnterはIMEに任せ、検索欄からフォーカスを外さない。
      if (composing || e.isComposing || e.keyCode === 229) return;
      if (e.key === 'Enter') { e.preventDefault(); if (timer) clearTimeout(timer); apply(true); q.blur(); }
    });
  }
  if (clear) clear.addEventListener('click', reset);

  for (var i = 0; i < chips.length; i++) {
    chips[i].addEventListener('click', function (e) {
      var btn = e.currentTarget;
      selectMachine(btn.getAttribute('data-m') || '');
      // スマホは1行の横スクロールなので、押したチップが見える位置に寄せる
      if (btn.scrollIntoView) btn.scrollIntoView({ block: 'nearest', inline: 'center' });
      apply(true);
    });
  }

  // 機種ページから #コード で飛んできた時は、その行を開いて見える位置に出す
  function openFromHash() {
    var h = (location.hash || '').replace(/^#/, '');
    if (!h) return;
    try { h = decodeURIComponent(h); } catch (e) { return; }
    for (var j = 0; j < chips.length; j++) {
      var key = chips[j].getAttribute('data-m');
      if (key && h.toLowerCase().endsWith('-' + key)) {
        h = h.slice(0, -(key.length + 1));
        selectMachine(key);
        apply();
        break;
      }
    }
    var target = byCode[codeKey(h)] || document.getElementById(h);
    if (!target) return;
    // 絞り込みで隠れていても開けるように、まず絞り込みを解除する
    if (target.hidden) {
      if (!matchesMachine(target)) selectMachine('');
      if (q) q.value = '';
      apply();
      if (q) q.blur();
    }
    var d = target.querySelector('details:not([hidden])');
    if (d) d.open = true;
    rows.forEach(function (r) { r.classList.remove('is-target'); });
    target.classList.add('is-target');
    target.scrollIntoView({ block: 'center' });
  }

  // ハブの検索窓から ?q=... で飛んできた時は、その語で絞った状態で開く。
  // 機種は ?m=... で指定できる（機種ページの「コードで探す」から使う）。
  function fromQuery() {
    var p;
    try { p = new URLSearchParams(location.search); } catch (e) { return false; }
    var term = (p.get('q') || '').trim();
    var m = (p.get('m') || '').trim();
    if (q) q.value = term;
    var known = Array.prototype.some.call(chips, function (chip) { return chip.getAttribute('data-m') === m; });
    selectMachine(known ? m : '');
    for (var j = 0; j < chips.length; j++) {
      if (chips[j].getAttribute('data-m') === machine) {
        // 横スクロールする機種一覧は、URLで選んだ機種も最初から見える位置へ。
        var strip = chips[j].parentElement;
        strip.scrollLeft = chips[j].offsetLeft - strip.offsetLeft - (strip.clientWidth - chips[j].offsetWidth) / 2;
        break;
      }
    }
    apply();
    return true;
  }

  window.addEventListener('hashchange', openFromHash);
  window.addEventListener('popstate', function () { fromQuery(); openFromHash(); });
  fromQuery();
  openFromHash();
})();
